// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goodstransportserviceinpune() {



const cardData = {


    keyword: "Goods Transport Services in Pune",

    headingDescription: "SSK Logistic provides organized goods transport services in Pune for manufacturers, distributors, traders, warehouses, retailers, corporate businesses, and industrial units requiring dependable movement of cargo across local, regional, and interstate routes. Transportation support can be arranged for commercial inventory, industrial materials, machinery, packaged products, heavy consignments, containers, full truck loads, and regular business shipments. With practical vehicle planning, route coordination, pickup scheduling, loading arrangements, and destination delivery support, SSK Logistic helps businesses manage their goods movement requirements from Pune to important commercial and industrial locations across Maharashtra and India.",

    topPlaces: [
        {
            title: "Bhosari MIDC",
            description: "Bhosari MIDC is a major industrial zone where businesses regularly move machinery, engineering components, raw materials, finished products, and commercial stock. SSK Logistic supports transportation requirements from this area with suitable vehicle coordination and practical arrangements based on cargo volume, loading needs, and delivery destination."
        },
        {
            title: "Ranjangaon",
            description: "Ranjangaon has a strong manufacturing and industrial presence, creating regular requirements for transportation of equipment, components, packaged goods, and factory materials. SSK Logistic coordinates goods movement from Pune toward Ranjangaon and surrounding industrial locations according to shipment size and vehicle requirements."
        },
        {
            title: "Talegaon MIDC",
            description: "Talegaon MIDC serves manufacturing, engineering, automotive, and warehouse operations that depend on organized goods movement. SSK Logistic can coordinate transportation for industrial materials, machinery, components, commercial inventory, and finished goods between Pune and Talegaon-based business locations."
        },
        {
            title: "Pune to Nagpur",
            description: "The Pune to Nagpur route connects western Maharashtra with an important central Indian commercial and distribution market. SSK Logistic supports businesses moving industrial materials, commercial stock, machinery, packaged goods, and larger consignments over this long-distance road corridor."
        },
        {
            title: "Vapi",
            description: "Vapi is an established industrial destination in Gujarat with manufacturing, chemical, packaging, and commercial activity. SSK Logistic assists Pune businesses with transportation toward Vapi for industrial supplies, finished products, machinery, and other business cargo requiring coordinated interstate road movement."
        },
        {
            title: "Pune to Jaipur",
            description: "Pune to Jaipur is a long-distance interstate transportation corridor used for commercial distribution and industrial cargo movement. SSK Logistic helps coordinate suitable road transportation for businesses sending machinery, inventory, packaged goods, equipment, and larger consignments toward Rajasthan."
        },
        {
            title: "Kolhapur",
            description: "Kolhapur is an important commercial and industrial center in southern Maharashtra with manufacturing and trading activity. SSK Logistic supports transportation between Pune and Kolhapur for industrial materials, commercial goods, machinery, finished products, and regular business inventory."
        },
        {
            title: "Pune to Raipur",
            description: "Pune to Raipur provides an important interstate connection for businesses transporting goods toward central India. SSK Logistic coordinates road transportation for industrial cargo, commercial consignments, equipment, raw materials, and finished products while considering vehicle capacity and long-distance route requirements."
        },
        {
            title: "Aurangabad Industrial Area",
            description: "The Aurangabad industrial belt, also known as Chhatrapati Sambhajinagar, has manufacturing and engineering businesses requiring regular cargo movement. SSK Logistic supports transportation of machinery, components, industrial supplies, commercial inventory, and finished goods between Pune and this industrial region."
        },
        {
            title: "Pune to Coimbatore",
            description: "Pune to Coimbatore is a significant long-distance route connecting industrial and manufacturing markets in western and southern India. SSK Logistic provides coordinated road transportation for larger commercial shipments, industrial materials, machinery, components, and business inventory moving toward Tamil Nadu."
        }
    ],

    "services": [
        {
            "name": "goods transport services pune",
            "description": "SSK Logistic coordinates goods transport services pune for businesses requiring organized movement of commercial, industrial, warehouse, and general cargo. Vehicle selection and transportation planning can be aligned with shipment size, cargo characteristics, pickup requirements, destination, and expected delivery schedule."
        },
        {
            "name": "goods transportation pune",
            "description": "Goods transportation pune requirements can include local dispatches, warehouse transfers, industrial deliveries, and long-distance interstate shipments. SSK Logistic helps businesses coordinate suitable road vehicles and transportation arrangements according to the nature and volume of their goods."
        },
        {
            "name": "goods transport company pune",
            "description": "Businesses searching for a goods transport company pune can coordinate their cargo requirements with SSK Logistic for local and long-distance road movement. Services are planned around vehicle capacity, cargo type, pickup location, destination, loading requirements, and practical delivery arrangements."
        },
        {
            "name": "goods transporters pune",
            "description": "SSK Logistic supports goods transporters pune requirements for manufacturers, distributors, traders, warehouses, and commercial businesses. Transportation arrangements can be coordinated for regular inventory movement, industrial cargo, packaged products, machinery, and larger business consignments."
        },
        {
            "name": "goods transport service provider pune",
            "description": "As a goods transport service provider pune, SSK Logistic assists businesses with planned road transportation for commercial and industrial shipments. From pickup coordination to vehicle allocation and destination delivery, transportation arrangements can be adapted to different cargo sizes and route requirements."
        },
        {
            "name": "goods transportation services pune",
            "description": "SSK Logistic manages goods transportation services pune for businesses moving products, materials, equipment, and inventory between operational locations. Transportation planning considers cargo quantity, vehicle suitability, loading conditions, route distance, and the specific delivery requirements of each shipment."
        },
        {
            "name": "commercial goods transport pune",
            "description": "Commercial goods transport pune is suitable for wholesalers, retailers, distributors, traders, and corporate businesses moving stock between warehouses, suppliers, and market locations. SSK Logistic coordinates practical road transportation based on shipment volume and destination requirements."
        },
        {
            "name": "industrial goods transport pune",
            "description": "Industrial goods transport pune requires appropriate vehicle capacity and attention to cargo weight, dimensions, loading conditions, and destination access. SSK Logistic supports manufacturers and industrial units transporting machinery, raw materials, components, equipment, and finished products."
        },
        {
            "name": "cargo transport services pune",
            "description": "SSK Logistic provides cargo transport services pune for businesses requiring structured transportation of commercial and industrial consignments. Suitable vehicle arrangements can be coordinated according to cargo volume, dimensions, pickup location, destination, and the operational requirements of the shipment."
        },
        {
            "name": "freight transport services pune",
            "description": "Freight transport services pune from SSK Logistic support businesses moving cargo between factories, warehouses, suppliers, distribution centers, and commercial destinations. Road freight arrangements can be coordinated for different shipment sizes and both Maharashtra and interstate routes."
        },
        {
            "name": "truck goods transport pune",
            "description": "Truck goods transport pune provides a practical option for businesses moving bulk commercial and industrial cargo by road. SSK Logistic coordinates appropriate truck transportation based on cargo quantity, loading requirements, route distance, vehicle capacity, and delivery location."
        },
        {
            "name": "full truck load goods transport pune",
            "description": "For larger shipments requiring dedicated vehicle capacity, full truck load goods transport pune offers a suitable road transportation arrangement. SSK Logistic coordinates FTL movement for machinery, industrial materials, commercial inventory, finished products, and bulk consignments across suitable routes."
        },
        {
            "name": "container goods transport pune",
            "description": "Container goods transport pune is useful for businesses moving larger containerized consignments between factories, warehouses, distribution centers, and commercial destinations. SSK Logistic coordinates suitable road transportation while considering container requirements, cargo characteristics, route distance, and delivery planning."
        },
        {
            "name": "road goods transport pune",
            "description": "SSK Logistic supports road goods transport pune for businesses moving cargo between industrial areas, warehouses, factories, retail locations, and interstate markets. Transportation can be planned around practical road routes, vehicle capacity, cargo requirements, and expected delivery timelines."
        },
        {
            "name": "local goods transport pune",
            "description": "Local goods transport pune helps businesses move stock, materials, equipment, and commercial cargo between nearby locations. SSK Logistic coordinates suitable vehicles for short-distance transportation involving warehouses, industrial units, suppliers, retailers, offices, and distribution points."
        },
        {
            "name": "interstate goods transport pune",
            "description": "SSK Logistic supports interstate goods transport pune for businesses sending commercial and industrial cargo beyond Maharashtra. Transportation can be coordinated toward Gujarat, Karnataka, Madhya Pradesh, Telangana, Rajasthan, Chhattisgarh, Tamil Nadu, Delhi NCR, and other business destinations."
        },
        {
            "name": "reliable goods transport pune",
            "description": "Businesses requiring reliable goods transport pune can coordinate shipment details with SSK Logistic for suitable vehicle and route planning. The transportation process can be organized around cargo type, shipment quantity, pickup requirements, destination, and scheduled delivery expectations."
        },
        {
            "name": "safe goods transportation pune",
            "description": "Safe goods transportation pune involves suitable vehicle selection, careful loading coordination, route planning, and responsible movement of cargo. SSK Logistic structures transportation arrangements according to the nature, dimensions, weight, and destination of each commercial or industrial shipment."
        },
        {
            "name": "affordable goods transport pune",
            "description": "SSK Logistic supports affordable goods transport pune requirements by coordinating transportation options according to shipment volume, route, and vehicle capacity. Businesses can select arrangements that match their cargo requirements instead of using unsuitable vehicle sizes for different loads."
        },
        {
            "name": "professional goods transport pune",
            "description": "Professional goods transport pune requires systematic coordination of pickup, loading, vehicle allocation, route planning, and delivery. SSK Logistic assists businesses with organized transportation arrangements for commercial inventory, industrial cargo, machinery, and regular business consignments."
        },
        {
            "name": "goods transport booking pune",
            "description": "Goods transport booking pune can be coordinated by sharing essential shipment information such as pickup point, destination, cargo type, approximate quantity, vehicle requirement, and preferred schedule. SSK Logistic uses these details to plan suitable road transportation."
        },
        {
            "name": "goods transport company near pune",
            "description": "Businesses searching for a goods transport company near pune can coordinate transportation requirements with SSK Logistic for nearby industrial locations as well as longer-distance destinations. Services can support warehouse transfers, commercial dispatches, factory cargo, and interstate shipments."
        },
        {
            "name": "heavy goods transport pune",
            "description": "Heavy goods transport pune requires careful consideration of cargo weight, dimensions, loading methods, vehicle capacity, and route conditions. SSK Logistic coordinates transportation for heavy machinery, industrial equipment, large materials, and other substantial commercial consignments."
        },
        {
            "name": "commercial transportation pune",
            "description": "Commercial transportation pune supports businesses moving products, inventory, machinery, supplies, and trading goods between suppliers, warehouses, factories, and market destinations. SSK Logistic coordinates road transportation according to cargo requirements, route distance, and vehicle capacity."
        },
        {
            "name": "industrial transportation services pune",
            "description": "Industrial transportation services pune from SSK Logistic are designed for manufacturers, engineering companies, factories, warehouses, and industrial suppliers. Transportation arrangements can accommodate raw materials, components, machinery, equipment, finished products, and larger industrial consignments."
        }
    ],

    "tableData": [
        ["goods transport services pune", "goods transportation pune"],
        ["goods transport company pune", "goods transporters pune"],
        ["goods transport service provider pune", "goods transportation services pune"],
        ["commercial goods transport pune", "industrial goods transport pune"],
        ["cargo transport services pune", "freight transport services pune"],
        ["truck goods transport pune", "full truck load goods transport pune"],
        ["container goods transport pune", "road goods transport pune"],
        ["local goods transport pune", "interstate goods transport pune"],
        ["reliable goods transport pune", "safe goods transportation pune"],
        ["affordable goods transport pune", "professional goods transport pune"],
        ["goods transport booking pune", "goods transport company near pune"],
        ["heavy goods transport pune", "commercial transportation pune"],
        ["industrial transportation services pune", "Goods Transport Services in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Transportation Planned Around Cargo",
            WhyChoosedescription: "SSK Logistic considers the shipment type, quantity, weight, dimensions, loading requirements, and destination while coordinating transportation. This approach helps businesses select practical vehicle arrangements for industrial materials, commercial goods, machinery, and larger consignments."
        },
        {
            WhyChooseheading: "Local and Long-Distance Movement",
            WhyChoosedescription: "Goods may need to travel a short distance within Pune or move across several states. SSK Logistic supports both requirements with route-based transportation coordination for industrial areas, warehouses, distribution centers, commercial markets, and interstate destinations."
        },
        {
            WhyChooseheading: "Support for Heavy and Bulk Cargo",
            WhyChoosedescription: "Large industrial shipments often require greater vehicle capacity and additional planning. SSK Logistic assists with transportation requirements involving heavy machinery, bulk materials, full truck loads, containers, equipment, and other substantial commercial consignments."
        },
        {
            WhyChooseheading: "Business-Focused Goods Movement",
            WhyChoosedescription: "Manufacturers, wholesalers, distributors, retailers, factories, warehouses, and corporate businesses can use coordinated transportation for regular and one-time cargo requirements. SSK Logistic structures road movement around practical business and operational needs."
        },
        {
            WhyChooseheading: "Flexible Route Selection",
            WhyChoosedescription: "Different shipments require different routes depending on the pickup point, destination, cargo type, and delivery schedule. SSK Logistic coordinates transportation across Pune industrial areas, Maharashtra markets, and interstate commercial corridors according to individual shipment requirements."
        },
        {
            WhyChooseheading: "Vehicle Capacity Consideration",
            WhyChoosedescription: "Choosing an appropriate vehicle is important for efficient goods transportation. SSK Logistic considers the size and quantity of the cargo when coordinating truck, full truck load, container, or other suitable road transportation arrangements."
        },
        {
            WhyChooseheading: "Organized Dispatch Coordination",
            WhyChoosedescription: "Pickup, loading, vehicle allocation, route movement, and delivery all form part of an effective transportation process. SSK Logistic helps businesses coordinate these requirements in a structured manner for smoother movement of commercial and industrial goods."
        },
        {
            WhyChooseheading: "Connectivity Across Major Markets",
            WhyChoosedescription: "Pune has strong road connections with industrial and commercial destinations across western, central, northern, and southern India. SSK Logistic supports transportation requirements toward varied markets including Gujarat, Rajasthan, Karnataka, Madhya Pradesh, Chhattisgarh, Tamil Nadu, and other regions."
        }
    ]

};











const faqData = [
    {
        question: "What goods transport services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic supports businesses with goods transportation from Pune for commercial, industrial, and business consignments, with vehicle arrangements based on cargo type, quantity, route, loading requirements, and delivery schedule."
    },
    {
        question: "Can SSK Logistic transport goods from Pune to other cities?",
        answer: "Yes, goods can be transported from Pune toward destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other cities across India."
    },
    {
        question: "What types of goods can be transported through SSK Logistic?",
        answer: "Transportation can be considered for machinery, industrial materials, commercial stock, equipment, packaged products, raw materials, finished goods, supplies, and other suitable consignments depending on their size and handling requirements."
    },
    {
        question: "Can SSK Logistic handle regular goods transportation for businesses?",
        answer: "Companies with recurring shipment requirements can discuss regular transportation arrangements based on their routes, cargo volume, pickup frequency, preferred vehicle capacity, and expected delivery timelines."
    },
    {
        question: "How is the right vehicle selected for goods transportation?",
        answer: "Vehicle selection depends on practical shipment details such as cargo weight, dimensions, quantity, volume, loading conditions, material type, route distance, and final delivery location."
    },
    {
        question: "Does SSK Logistic provide Pune to Mumbai goods transport services?",
        answer: "Pune to Mumbai transportation can be arranged for commercial inventory, industrial supplies, machinery, equipment, packaged goods, business materials, and other suitable cargo requiring movement between the two cities."
    },
    {
        question: "Can SSK Logistic transport goods outside Maharashtra?",
        answer: "Interstate goods movement can also be coordinated from Pune toward Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other destinations based on the shipment and route requirements."
    },
    {
        question: "Are SSK Logistic goods transport services suitable for industrial companies?",
        answer: "Manufacturers, suppliers, distributors, warehouses, and industrial units can use the service for transporting raw materials, finished products, machinery, equipment, commercial inventory, and other business-related goods."
    },
    {
        question: "Can goods transportation be planned according to specific shipment requirements?",
        answer: "Yes, transportation can be planned around the pickup point, delivery destination, type of goods, shipment quantity, vehicle capacity, loading conditions, preferred delivery timeframe, and frequency of transportation."
    },
    {
        question: "How can I book or enquire about goods transport services from SSK Logistic?",
        answer: "Share the pickup location, delivery destination, cargo type, approximate weight or quantity, dimensions if relevant, loading details, vehicle requirement, and preferred delivery schedule to discuss the appropriate transportation arrangement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Deepak Ranade",
        feedback: "We needed to transport finished products from Pune to Surat for our business. SSK Logistic understood the shipment details and coordinated the vehicle requirement according to the quantity and route.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Anjali Sawant",
        feedback: "SSK Logistic helped us move commercial materials from Pune to Bengaluru. The team was responsive during the coordination, and the transportation arrangement matched our business requirements well.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goods Transport Services in Pune",
  "image": "https://ssklogistics.in/assets/images/goods-transport-services-in-pune.webp",
  "description": "SSK Logistics provides Goods Transport Services in Pune for businesses requiring organized and dependable movement of commercial goods, materials, cargo and consignments across local, regional and interstate routes. Goods transport services Pune requirements can include regular shipment movement, vehicle coordination, route planning and transportation arrangements based on cargo volume, destination and delivery schedules. Businesses searching for goods transportation Pune can coordinate the movement of industrial materials, commercial products, machinery, packaged goods, retail stock and other business consignments through suitable transportation solutions. As a goods transport company Pune, SSK Logistics supports manufacturers, distributors, wholesalers, retailers, traders and commercial establishments with practical goods movement and logistics coordination. Goods transporters Pune requirements may involve arranging appropriate vehicles for different load capacities and transportation routes, while a goods transport service provider Pune can assist with planned dispatches, recurring shipments and destination-based transportation needs. SSK Logistics also supports commercial and industrial goods movement from Pune to various cities across Maharashtra and interstate destinations, with an emphasis on responsive coordination, suitable vehicle arrangements and smooth transportation planning.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Goods Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/goods-transport-services-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Goods Transport Services in Pune | Reliable Goods Transportation & Transporters | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers goods transport services in Pune for commercial and industrial consignments, including goods transportation, vehicle coordination and regional & interstate delivery."
  />

  <meta
    name="keywords"
    content="Goods Transport Services in Pune, goods transport services pune, goods transportation pune, goods transport company pune, goods transporters pune, goods transport service provider pune, goods transport service Pune, goods transportation services Pune, goods transport company in Pune, goods transporters in Pune, goods transportation company Pune, commercial goods transport Pune, industrial goods transport Pune, cargo transportation Pune, freight transportation Pune, commercial transportation Pune, business goods transport Pune, local goods transport Pune, interstate goods transport Pune, Maharashtra goods transport Pune, truck transport Pune, goods vehicle transport Pune, goods carrier Pune, goods logistics Pune, goods delivery services Pune, reliable goods transport Pune, B2B goods transportation Pune, heavy goods transport Pune, commercial cargo transport Pune, industrial transportation Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goodstransportserviceinpune;